<template>
  <div class="text-center">
    <picture>
      <source media="(max-width: 1199px)" srcset="@/assets/images/Reem/success.png">
      <img src="@/assets/images/Reem/success@2x.png" alt="step image">
    </picture>
    <h3 class="title">Great job!</h3>
    <div class="sub-title">In the next step you will need to select the relevant Google Ads account</div>
  </div>
</template>

<script>
export default {
  name: "SuccessMsg"
}
</script>

<style scoped>
img {
  height: 292px;
}
.sub-title {
  margin: 0 auto;
  max-width: 514px;
}
</style>